import React, { useContext } from 'react'
import { Container } from '@material-ui/core'
import { AuthenticatedUserContext } from '../../../AuthenticatedUserContext'
import { SearchLoader } from '../../Loader/SearchLoader'
import InActiveUserContent from '../../InActiveUserContent'
import Alert from '@material-ui/lab/Alert'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './Styles'
import UnAuthorize from '../../UnAuthorize'
import EmptyResult from '../../EmptyResult'
import WorkspaceTable from '../Table'
import { NonCoreLinkRequestsContext } from '../../../nonCoreLinkRequestsContext'

const NonCoreLinkRequestsContent = () => {
  const classes = useStyles()

  const {
    headerColumns,
    nonCoreLinkRequests,
    nonCoreLinkRequestsLoading,
    nonCoreLinkRequestsFailure,
    nonCoreLinkRequestsFailure403
  } = useContext(NonCoreLinkRequestsContext)

  const { userDataLoading, isUserActive, userData } = useContext(AuthenticatedUserContext)
  return (
    <>
      <Container maxWidth="lg" className={classes.TitleContainer}>
        <h1><FormattedMessage id='workspaceMenu.link.item13'/></h1>
      </Container>

      <Container maxWidth="lg" className={classes.CompaniesContentContainer}>
        {!!userDataLoading && <SearchLoader loading={true}/>}
        {(!!Object.keys(userData).length && !!isUserActive) ?
          (!!nonCoreLinkRequestsLoading ? <SearchLoader loading={true}/> :
              !!nonCoreLinkRequestsFailure ?
                (!!nonCoreLinkRequestsFailure403 ? <UnAuthorize/> :
                  <Alert severity="error"><FormattedMessage id='BasicInfo.FormErrorAlert'/></Alert>)
                :
                ((nonCoreLinkRequests === undefined || nonCoreLinkRequests.length === 0) ?
                    <EmptyResult isNonCoreRequests/> :
                    <WorkspaceTable
                      noFilter
                      loadRows={() => {}}
                      hasMoreRows={false}
                      rows={nonCoreLinkRequests}
                      columns={headerColumns}
                      size={'medium'}
                    />
                )
          )
          : (!userDataLoading && <InActiveUserContent/>)
        }
      </Container>
    </>
  )
}

export default NonCoreLinkRequestsContent
